export var RateTypes;
(function (RateTypes) {
    RateTypes["INTEREST_RATE"] = "interestRate";
    RateTypes["COMPARISON_RATE"] = "comparisonRate";
    RateTypes["PAYMENT_TERM"] = "paymentTerm";
    RateTypes["DEPOSIT_PERCENTAGE"] = "depositPercentage";
    RateTypes["UPFRONT_PAYMENT"] = "sticky_footer_upfront_payment_label";
    RateTypes["CAE"] = "cae";
})(RateTypes || (RateTypes = {}));
//# sourceMappingURL=RateTypes.js.map